import Auth from '../../models/Auth'
import * as Types from '../../constants/actionTypes'
import PasswordHandling from '../../models/PasswordHandling'
import Axios from 'axios'
import { AUTH_SERVICE_URL } from '../../helper/constant'
import AuthAxios from '../../models/Axios'
/* Login Functionality */
export const SET_USER_LOGIN = (payload) => async (dispatch) => {
    try {
        const { username, password } = payload
        if (!username || !password) {
            dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: `Please Provide User Information ` });
            return
        }
        if (Auth.portalId) {
            payload['portalId'] = Auth.portalId
            payload['clientId'] = Auth.clientId
        } else {
            delete payload['portalId']
            delete payload['clientId']
        }
        const userData = await Auth.loginWithUserNameAndPassword(payload)

        if (Auth.token && !Auth.isTokenExpired) {
            dispatch({ type: Types.SET_TOKEN, token: Auth.token })
            dispatch({ type: Types.SET_REFRESH_TOKEN, refreshToken: Auth.refreshTK })
            dispatch({ type: Types.IS_USER_AUTHENTICATED, isUserAuthenticated: Auth.isUserAuthenticated })
        } else {
            if (userData) {
                let { code, cognitoUser, qrCode, message } = userData;
                if (code === 'SMS_MFA' || code === 'SOFTWARE_TOKEN_MFA') {
                    if (code === 'SMS_MFA' && cognitoUser) {
                        dispatch({ type: Types.SET_MFA_SESSION, session: cognitoUser, mfaType: 'SMS_MFA' })
                    } else if (code === 'SOFTWARE_TOKEN_MFA' && cognitoUser) {
                        dispatch({ type: Types.SET_MFA_SESSION, session: cognitoUser, mfaType: 'SOFTWARE_TOKEN_MFA', qrCode: qrCode })
                    }
                } else if (code === 'PORTAL_SAME_USER') {
                    dispatch({ type: Types.LIST_PORTAL_SAME_USER, authErrorCode: code, authLoginError: message, portalsSameUser: userData.portals });
                }
            }
            dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: '', authErrorCode: '' })
        }
        return { nextLoginTryTime: 0, code: '', message: '', ...userData, }
    } catch (error) {
        console.log('SET_USER_LOGIN error', error)
        const response = error.response;
        const data = response.data.error
        let { code, message, nextLoginTryTime } = data;
        dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: message, authErrorCode: code })
        return { ...data, nextLoginTryTime: nextLoginTryTime || 0, message, code };
    }
}
export const CLEAR_USER_SESSION = () => (dispatch) => {
    dispatch({ type: Types.SET_MFA_SESSION, session: null, mfaType: null })
}

export const VERIFY_USER_MFA = (payload) => async (dispatch) => {
    try {
        const { username, verifyCode, portalId, clientId, session } = payload
        if (!username || !verifyCode || !portalId) {
            dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: `Please Provide User Information` });
            return
        }
        if (!session) {
            dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: `Authentication Failed. Please Try Later` });
        }
        const userData = await Auth.verifyUserMFA(payload)

        if (Auth.token && !Auth.isTokenExpired) {
            dispatch({ type: Types.SET_TOKEN, token: Auth.token })
            dispatch({ type: Types.SET_REFRESH_TOKEN, refreshToken: Auth.refreshTK })
            dispatch({ type: Types.IS_USER_AUTHENTICATED, isUserAuthenticated: Auth.isUserAuthenticated })
        }

        return userData
    } catch (exception) {
        return dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: exception.message });
    }
}

export const SEND_USER_MAIL_OTP = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/portal/loginOtp`
    try {
        const response = await Axios.post(URL, payload);
        dispatch({ type: Types.COGNITO_USER_DETAILS, data: (response.data && response.data.data) })
    } catch (error) {
        dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: error.message })
    }
}

export const SUBMIT_USER_OTP = (payload) => async (dispatch) => {
    const URL = `${AUTH_SERVICE_URL}/portal/loginOtpVerify`
    try {
        Auth._clearUserCache();
        const { data } = await Axios.post(URL, payload);
        dispatch({ type: Types.USER_LOGIN_DETAILS, data: (data && data.data) })
        if (data && data.data) {
            Auth.setUserData(data.data)
        }

        if (Auth.token && !Auth.isTokenExpired) {
            dispatch({ type: Types.SET_TOKEN, token: Auth.token })
            dispatch({ type: Types.SET_REFRESH_TOKEN, refreshToken: Auth.refreshTK })
            dispatch({ type: Types.IS_USER_AUTHENTICATED, isUserAuthenticated: Auth.isUserAuthenticated })
        }
    } catch (error) {
        dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: error.message })
    }
}

export const SET_LOGIN_AUTH_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: message, authErrorCode: '' });
}
export const SET_IS_USER_AUTHENTICATED = (isUserAuthenticated) => (dispatch) => {
    dispatch({ type: Types.IS_USER_AUTHENTICATED, isUserAuthenticated })
}


/* Forgot Password and change Password Actions */


/* ----- Forgot Password actions Start ----- */

export const ADMIN_INIT_FORGOT_PASSWORD = (payload) => async (dispatch) => {
    const { username } = payload
    if (!username) {
        return dispatch({ type: Types.FORGOT_PASSWORD_ERROR, forgotPswdError: `Please Provide User Name ` })
    }
    try {
        const response = await PasswordHandling.initiateForgotPassword(payload);
        // console.log(`init Forgot Password :`, initForgotPWD);
        if (response && response.code === 'USERNAME_NOT_FOUND') {
            return dispatch({ type: Types.FORGOT_PASSWORD_ERROR, forgotPswdError: response.message })
        }
        return response;
    } catch (error) {
        const _err = (error.error && error.error.message) ? error.error.message : error.message;
        return dispatch({ type: Types.FORGOT_PASSWORD_ERROR, forgotPswdError: _err })
    }
}

export const SET_ADMIN_FORGOT_PASSWORD_ERROR = (message) => (dispatch) => {
    dispatch({ type: Types.ADMIN_FORGOT_PASSWORD_ERROR, forgotPswdError: message })
}

export const CONFIRM_FORGOT_PASSWORD = (payload) => async (dispatch) => {
    try {
        const { username, password } = payload
        if (!username || !password) {
            return dispatch({ type: Types.ADMIN_FORGOT_PASSWORD_ERROR, forgotPswdError: `Please Provide Valid New User Password Information ` })
        }

        let res = await PasswordHandling.confirmPasswordResponse(payload)
        return res
        //console.log(`confimPswdResponse is `, confirmPswdResponse);
    } catch (exception) {
        let err = dispatch({ type: Types.ADMIN_FORGOT_PASSWORD_ERROR, forgotPswdError: exception.message })
        return { ...exception, ...err }
    }
}

/* ----- Change Password Actions Start */
export const ON_CHANGE_NEW_PWD = async (payload) => async (dispatch) => {
    try {
        const { username, password, newPassword } = payload
        if (!username || !password || !newPassword) {
            return dispatch({ type: Types.ADMIN_CHANGE_PASSWORD_ERROR, changePWDError: `Please provide Valid User Password Information` })
        }
        let res = await PasswordHandling.onChangeNewPassword(payload)
        return res
    } catch (exception) {
        let err = dispatch({ type: Types.ADMIN_CHANGE_PASSWORD_ERROR, changePWDError: exception.message })
        return { ...exception, ...err }
    }
}

export const SET_CHANGE_PWD_ERROR = (message) => (dispatch) => {
    return dispatch({ type: Types.ADMIN_CHANGE_PASSWORD_ERROR, changePWDError: message })
}



/* Forgot password & change pwd end */
export const SET_LOGOUT = () => async (dispatch) => {
    dispatch({ type: Types.ON_LOGOUT });

    // /auth/portal/user-logout
    Auth.logout();
}

/* Forgot password & change pwd end */
export const SET_LOGOUT_BY_USER = () => async (dispatch) => {
    const payload = {
        username: Auth.username,
        token: Auth.token,
        RTK: Auth.refreshTK,
        portalId: Auth.portalId,
        clientId: Auth.clientId,
    }
    const headers = {
        'Authorization': `Bearer ${Auth.token}`,
        'x-userId': Auth.userId,
    }
    await AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portal/user-logout`, payload, { headers }).then(result => { }).catch(err => { })
    // /auth/portal/user-logout
    Auth.logout();
    dispatch({ type: Types.ON_LOGOUT });

}

export const SET_IS_UNAUTHORIZED = (isUnauthorized) => async (dispatch) => {
    dispatch({ type: Types.SET_UNAUTHORIZED_ERROR, payload: isUnauthorized });
}

// Authentication of Users
export const PORTAL_USER_ACTIVATION_VERIFY_EMAIL = (payload) => async (dispatch) => {
    try {
        const { username, portalId, token } = payload
        if (!(username && portalId && token)) {
            dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage: 'Please provide required information' })
            return
        }
        const response = await Axios.post(`${AUTH_SERVICE_URL}/portal/portal-user-verify`, payload);
        const data = response.data && response.data
        if (data) {
            dispatch({ type: Types.INITIATE_SET_PASSWORD_SUCCESS })
        }
        return data
    } catch (error) {
        console.log('Error', error)
        let response = error.response
        response = response && response.data
        if (response && response.code === 'RESEND_ACTIVATION_REQUIRED') {
            return dispatch({ type: Types.USER_ACTIVATION_INITIATE_RESEND_ACTIVATION })
        }
        dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage: error.message })
    }
}

export const PORTAL_USER_ACTIVATION_VERIFY_CHANGE_PASSWD = (payload) => async (dispatch) => {
    try {
        const { username, portalId, token, password, code } = payload
        if (!(username && portalId && token && password && code)) {
            dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage: 'Please provide required information' })
            dispatch({ type: Types.INITIATE_SET_PASSWORD_SUCCESS })
            return
        }
        const response = await Axios.post(`${AUTH_SERVICE_URL}/portal/portal-user-verify`, payload);
        const data = response.data && response.data
        if (data && data.code === 'NEED_TO_CHANGE_USER_PASSWORD') {
            const errorMsg = (data.message && typeof data.message === 'string') ? data.message : 'Please provide required information'
            dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage: errorMsg })
            dispatch({ type: Types.INITIATE_SET_PASSWORD_SUCCESS })
        }
        return data
    } catch (error) {
        console.log('Error', error)
        let response = error.response
        const data = response && response.data
        if (data && data.code === 'RESEND_ACTIVATION_REQUIRED') {
            return dispatch({ type: Types.USER_ACTIVATION_INITIATE_RESEND_ACTIVATION })
        }
        let errorMessage = 'An error occurred. Please try again.'
        if (response && response.data) {
            if (response.data.error && response.data.error.message && typeof response.data.error.message === 'string') {
                errorMessage = response.data.error.message
            } else if (response.data.message && typeof response.data.message === 'string') {
                errorMessage = response.data.message
            } else if (typeof response.data === 'string') {
                errorMessage = response.data
            }
        } else if (error.message && typeof error.message === 'string') {
            errorMessage = error.message
        }
        dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage })
    }
}

export const RESEND_ACTIVATION_LINK_BY_USER = (payload) => async (dispatch) => {
    try {
        const { username, portalId, token } = payload
        if (!token || !username || !portalId) {
            return;
        }
        await Axios.post(`${AUTH_SERVICE_URL}/portal/resend-account-activation-link`, payload);
        dispatch({ type: Types.PORTAL_USER_ACTIVATION_RESEND_LINK_SUCCESS })

    } catch (error) {
        let response = error.response
        // let message = response && response.message
        let message = response && response.error && response.error.message
        if (!message) {
            message = response && response.message
        }
        dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage: message })
    }
}

export const SET_USER_ACTIVATION_ERROR_MESSAGE = (message) => (dispatch) => {
    dispatch({ type: Types.PORTAL_USER_ACTIVATION_FAILED, errorMessage: message })
}

export const UN_AUTHORIZED_TROZEN_ACCESS = (isNotAllowedAlready) => async (dispatch) => {
    if (!isNotAllowedAlready) {
        dispatch({ type: Types.ON_LOGOUT });

        dispatch({ type: Types.INITIATE_UNAUTHORIZED_ACCESS })
        if (Auth.username && Auth.portalId && Auth.clientId) {
            const logoutPayload = {
                username: Auth.username,
                portalId: Auth.portalId,
                clientId: Auth.clientId
            }
            await AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portal/user-logout`, logoutPayload)

        }
        Auth.logout();
    }
}
// Fetch SAML Login Url
export const FETCH_SAML_SSO_AUTHENTICATE_URL = (payload) => async (dispatch) => {
    try {
        // console.log(`provider name is :`, providerName)
        const response = await Axios.post(`${AUTH_SERVICE_URL}/portal/getSSOOAuth2URL`, payload)
        let ssoData = (response && response.data && response.data.data)
        return ssoData
    } catch (error) {
        console.log(`Fetch SSO Error`, error)
        return error
    }
}

export const SSO_PORTAL_AUTH_VERIFY = (payload) => async (dispatch) => {
    try {
        console.log('--------------------------------SSO_PORTAL_AUTH_VERIFY-----------------------------')
        Auth._clearUserCache();
        const { portalId, clientId, code } = payload
        if (!portalId || !clientId || !code) {
            return
        }
        const { data } = await Axios.post(`${AUTH_SERVICE_URL}/portal/verifySSOAuthorization`, payload)
        if (data && data.data) {
            Auth.setUserData(data.data)
        }
        if (Auth.token && !Auth.isTokenExpired) {
            dispatch({ type: Types.SET_TOKEN, token: Auth.token })
            dispatch({ type: Types.SET_REFRESH_TOKEN, refreshToken: Auth.refreshTK })
            dispatch({ type: Types.IS_USER_AUTHENTICATED, isUserAuthenticated: Auth.isUserAuthenticated })
        }
    } catch (error) {
        console.log(`Fetch Portal-Auth Verify`);
    }
}

export const FORGOT_USERNAME = (portalId, email) => (dispatch) => {
    return Axios.post(`${AUTH_SERVICE_URL}/portal/getusernamebyemail`, { portalId, email })
}

export const CREATE_USER_REGISTRATION_FORM = async (payload) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portal/createUserForRegistrationFormv2`, payload);
        if (response.data && response.data.data) {
            return response.data.data
        } else if (response.data && response.data.code) {
            return response.data
        }
    } catch (error) {
        return error
    }
}

export const APPROVE_REGISTRATION_FORM = async (payload) => {
    try {
        const { portalId } = payload
        if (!portalId) {
            return ({ message: `Please Provide Portal User Information` })
        }
        const response = await AuthAxios.axios.post(`${AUTH_SERVICE_URL}/portal/createUserForRegistrationFormv4`, payload);
        if (response.data && response.data.data) {
            return response.data.data
        } else if (response.data && response.data.code) {
            return response.data
        }
    } catch (error) {
        return error
    }
}


export const RESET_PORTAL_USER_PASSWORD = (payload) => async (dispatch) => {
    try {
        const { username, newPassword, password } = payload
        if (!username || !newPassword || !password) {
            return
        }
        await Axios.post(`${AUTH_SERVICE_URL}/portal/reset-password`, payload);

    } catch (error) {
        let response = error.response
        const data = response && response.data && response.data.error;
        let message = data && data.message
        if (message === "Incorrect username or password.") {
            message = "Current Password is incorrect"
        }
        if (!message && response && response.data && response.data.message) {
            message = response.data.message
        }
        if (!message || typeof message !== 'string') {
            message = error.message && typeof error.message === 'string' ? error.message : 'An error occurred. Please try again.'
        }
        dispatch({ type: Types.PORTAL_USER_RESET_PASSWORD_FAILED, errorMessage: message })
    }
}

export const SET_USER_RESET_PASSWORD_ERROR_MESSAGE = (message) => (dispatch) => {
    dispatch({ type: Types.PORTAL_USER_RESET_PASSWORD_FAILED, errorMessage: message })
}

export const SET_LOGIN_ADMIN_TOKEN = (payload) => async (dispatch) => {
    try {
        let { token, userId, userType, cId, pId, portalType } = payload
        if (!(token && userId && userType && cId && pId && portalType)) {
            dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: `Please Provide User Information ` });
            return
        }
        const authResponse = await Auth.loginWithAdminToken(payload)

        if (Auth.token && !Auth.isTokenExpired) {
            dispatch({ type: Types.SET_TOKEN, token: Auth.token })
            dispatch({ type: Types.SET_REFRESH_TOKEN, refreshToken: Auth.refreshTK })
            dispatch({ type: Types.IS_USER_AUTHENTICATED, isUserAuthenticated: Auth.isUserAuthenticated })
        }

        return authResponse
    } catch (error) {
        console.log('SET_USER_LOGIN error', error)
        dispatch({ type: Types.AUTH_LOGIN_ERROR, authLoginError: error.message })

        const response = error.response;
        const data = response.data.error
        // const code = (data && data.code)||''
        let nextLoginTryTime = (data && data.nextLoginTryTime) || 0
        return nextLoginTryTime;
    }
}